/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable */
import React, { useRef } from 'react';
import { makeStyles, RACButton, RACModal, Typography } from '@rentacenter/racstrap';
import ReactToPrint from 'react-to-print';
import i18n from '../../i18n';
import ComponentToPrint from './ComponentToPrint';
import { FieldSheet, FieldSheetSection6Retention } from '../../types/types';

export interface FieldSheetPreviewProps {
  fieldSheets?: FieldSheet[];
  retentionOffers: FieldSheetSection6Retention[];
  isLoading: boolean;     
  onClose: () => void;
  onSave: () => void;
  carInstructions?: string;
}

const useStyles = makeStyles((theme: any) => ({
  fieldSheetContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: theme.typography.pxToRem(30),
    background: 'white',
  },
  underline: {
    textDecoration: 'underline',
  },
  dialogContent: {
    textAlign: 'center',
    margin: `2rem 0`,
  },
  dialogActions: {
    justifyContent: 'flex-end',
    position: 'sticky',
    bottom: 0,
  },
  dialogRoot: {
    '& .MuiPaper-rounded': {
      borderRadius: theme.typography.pxToRem(12),
    },
    '& .MuiDialog-paperWidthXs': {
      maxWidth: theme.typography.pxToRem(500),
    },
    '& .MuiTypography-h5': {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 500,
      lineHeight: theme.typography.pxToRem(30),
    },
  },
  previewContainer: {
    height: theme.typography.pxToRem(600),
    pageBreakInside: 'avoid',
    '& div': {
      pageBreakInside: 'avoid',
    },
  },
}));

export const FieldSheetPreview = ({
  fieldSheets = [],
  retentionOffers,
  isLoading,
  onClose,
  onSave,
  carInstructions,
}: FieldSheetPreviewProps) => {
  const classes = useStyles();
  const componentRef = useRef<any>(null);


  return (
    <RACModal
      isOpen
      classes={{
        dialogContent: classes.dialogContent,
        dialogActions: classes.dialogActions,
        dialog: classes.dialogRoot,
      }}
      maxWidth="lg"
      title={i18n.t('Field Sheet')}
      content={
        <div className={classes.previewContainer}>
          {fieldSheets.length === 0 ? (
            <Typography>{i18n.t("No field sheets available to display.")}</Typography>
          ) : (
            <ComponentToPrint
              fieldSheets={fieldSheets}
              retentionOffers={retentionOffers}
              ref={componentRef}
              carInstructions={carInstructions}
            />
          )}
        </div>
      }
      onClose={onClose}
      buttons={
        <>
          <RACButton variant="outlined" color="secondary" onClick={onClose}>
            {i18n.t('Cancel')}
          </RACButton>
          <ReactToPrint
            onAfterPrint={onSave}
            trigger={() => (
              <RACButton
                variant="contained"
                color="primary"
                loading={isLoading}
                disabled={isLoading || fieldSheets.length === 0}
              >
                {i18n.t('OK')}
              </RACButton>
            )}
            content={() => componentRef.current}
          />
        </>
      }
    />
  );
};